import { render, staticRenderFns } from "./SelectiveOffersList.vue?vue&type=template&id=63e027d0&scoped=true&"
import script from "./SelectiveOffersList.vue?vue&type=script&lang=js&"
export * from "./SelectiveOffersList.vue?vue&type=script&lang=js&"
import style0 from "./SelectiveOffersList.vue?vue&type=style&index=0&id=63e027d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e027d0",
  null
  
)

export default component.exports